const ActionConstants = require('./action');
const ApplicationConstants = require('./application');
const AttachmentConstants = require('./attachment');
const AuditConstants = require('./audit');
const ClientConstants = require('./client');
const CourierConstants = require('./courier')
const CommentConstants = require('./comment');
const ConfigurationConstants = require('./config-constants');
const ContractConstants = require('./contract');
const ContractDateConstants = require('./contract-date-management');
const ConsigneeConstants = require('./consignee');
const ConsigneeUserConstants = require('./consignee-user');
const ClearingHouseAgent = require('./exim/clearing-house-agent');
const ContainerConstants = require('./exim/container');
const eximImportExportType = require('./exim/type');
const CustomFieldConstants = require('./custom-fields');
const DashboardConstants = require('./dashboard');
const DBConnectionConstants = require('./db-connection');
const DetentionConstants = require('./detention');
const EmailType = require('./email-type');
const ExceptionConstants = require('./exception');
const HttpResponseContants = require('./http-response');
const InvoiceContants = require('./invoice');
const IndianStates = require('./india-states');
const MdmConstants = require('./mdm');
const OptimaConstants = require('./optima');
const OrderConstants = require('./order');
const PaymentConstants = require('./payment');
const TimelineConstants = require('./timeline');
const UtilisationStatus = require('./utilization-status');
const LocationTracker = require('./location-tracker');
const TrackAndTrace = require('./track-and-trace');
const PushNotification = require('./push-notification');
const Queue = require('./queue');
const HolidayConstants = require('./holiday-constants');
const RoleAssociates = require('./role-associates');
const Wallet = require('./wallet');
const WalletV2 = require('./wallet-v2');
const WorkerJobs = require('./worker-jobs');
const TrackingQueues = require('./tracking-queues');
const Location = require('./location');
const NimbusConstants = require('./nimbus/nimbus');
const NimbusModules = require('./nimbus/nimbus-settings');
const NimbusDataTypes = require('./nimbus/nimbus-data-types');

const IdentityProviders = require('./identity-providers');

const FreightUnit = require('./freightUnit');

const MaterialCategoryConstants = require('./material-category');
const Transporter = require('./transporter');
const SourceCharge = require('./source-charge');
const TransporterMailerConstants = require('./transporter-mailer');
const ConsigneeMailerConstants = require('./consignee-mailer');
const SlaDefaultConfig = require('./sla-config');
const DepotConstant = require('./depot');
const MaterialConstants = require('./material');
const UpdatedByUserType = require('./updated-by-user-type');

const WorkFlowConstants = require('./workflow');

const Port = require('./exim/port');
const FreightForwarder = require('./exim/freight-forwarder');
const FreightForwarderUser = require('./exim/freight-forwarder-user');
const ChaUser = require('./exim/cha-user');
const EximMailer = require('./exim/exim-mailer');

const EximType = require('./exim/type');
const MasterIndentType = require('./master-indent/type');
const MasterIndent = require('./master-indent');
const DriverAppConstants = require('./driver-app-constants');
const PurchaseOrderConstants = require('./purchase-order');
const FreightBillConstants = require('./freight-bill');
const ReportConstants = require('./report');

const DateRollConstants = require('./date-roll');

const definitionStrategies = require('./field_definitions');

const ErpBulkIndentConstants = require('./erp/bulk-indent');
const UnitsConstants = require('./erp/delivery/units');

const PackingConstants = require('./packing');
const DataValuesConstants = require('./data-values');

const MaraudersMap = require('./marauders-map');

const months = require('./month');
const vehicleDetail = require('./vehicle-detail');
const VehicleETA = require('./vehicle-eta');

const MongoDuplicateError = 11000;
const MaxConsigneeFavouriteLimit = 25;
const InternalServices = require('./internal-service');
const ThirdPartyIntegrationConstants = require('./thrid-party-integrations');
const TransitDelayConstants = require('./transit-delay-settings');
const InsuranceThresholdConstanst = require('./insurance-threshold-constants');
const SobConstants = require('./share-of-business');
const DetentionConfigurationConstants = require('./configuration/detention-configuration');
const ErrorMessages = require('./configuration/error');
const LrConfigurationConstants = require('./configuration/lr-configuration');
const MaterialHeaderConfigurationConstants = require('./configuration/material-header-configuration');
const NotificationConstants = require('./configuration/notifications-configuration');
const PaidInvoiceExportConstants = require('./configuration/paid-invoice-export-constants');
const SlaConfigurationConstants = require('./configuration/sla-configuration');
const SlotConfigurationConstants = require('./configuration/slot-configuration');
const UnitConfigurationConstants = require('./configuration/unit-configuration');

const dbActions = require('./configuration/index');

const BillDiscount = require('./bill-discount');
const contractTSDMapConstant = require('./contract-tsd-map');
const conversationSection = require('./conversation');
const costCenter = require('./cost-center');
const DedicatedTruck = require('./dedicated-truck');
const DieselPegConstants = require('./diesel-peg');
const erpConstants = require('./erp');
const headerMapFields = require('./extra-drop-charges');
const freightProvision = require('./freight-provision');
const GateConstants = require('./gate');
const defaultGrnHeader = require('./grn-materials');
const indentMaterialConstants = require('./indent-materials');
const invoicePermissionConstants = require('./invoice-permission');
const invoiceStatusConstants = require('./invoice-status');
const costCenterLoading = require('./loading-unloading'); // ----> TO DO naming to be checked and changed
const LocationMilestone = require('./location-milestone');
const OptimaConfiguration = require('./optima-configuration');
const ewayBillConstants = require('./eway-bill');
const OrdersConstants = require('./orders');
const Gst = require('./pando-gst');
const rateMatrix = require('./rate-matrix');
const RFQConstants = require('./rfq');
const slaCostCenter = require('./sla-charges');
// const StatusList = require('./status-list');
const TransitManagement = require('./transit-management');
const TransportationDbConstants = require('./transportation-db');
const RatingWeights = require('./transporter-rating-constants');
const TRANSPORTER_ROLES = require('./transporter-roles');
const user = require('./user');
const VehicleDetail = require('./vehicle-detail-master');
const Vehcile = require('./vehicle');
const Driver = require('./driver');
const VehicleDetails = require('./vehicledetail');
const localisationConstants = require('./localisation/default');

const headerMapping = require('./header-mapping');
const indentDestinationCharges = require('./indent-destination-charges');
const approvalConstants = require('./approval');
const LrSeriesTypeConstants = require('./lr_series_type');
const packagesConstants = require('./packages');
const MaterialPackageMappingConstants = require('./material-package-mapping');
const routerMasterConstants = require('./route-master');

const userAssociateConstants = require('./user-associate');
const DestinationChargeConstants = require('./destination-charge');
const materialThroughputConstants = require('./material-throughput');
const activityTimeConstants = require('./activity-time');
const ChargeableWeightConstants = require('./chargeable-weight');
const DeviationNotification = require('./deviation-notifications');
const fcmDeviationNotificationMessage = require('./exception-notification-messages');
const Transshipment = require('./transshipment');
const Redirection = require('./redirection');
const OptimaMaterialCategory = require('./optima/optima-material-category');
const FreightZoneConstants = require('./freight-zone');
const IntegrationLogsConstants = require('./integration-logs');
const LegalEntityConstants = require('./legal-entity');
const ReturnManagement = require('./return-management');
const PaySettlement = require('./pay-settlement');
const appDefaultConstants = require('./app-default-constant');
const PermissionsList = require('./permissions-list');
const FeaturesList = require('./features-list');
const PandoIntelligence = require('./pando-intelligence');

let constants = { };

constants = Object.assign(constants, ActionConstants);
constants = Object.assign(constants, ApplicationConstants);
constants = Object.assign(constants, AttachmentConstants);
constants = Object.assign(constants, AuditConstants);
constants = Object.assign(constants, ClientConstants);
constants = Object.assign(constants, CommentConstants);
constants = Object.assign(constants, ConfigurationConstants);
constants = Object.assign(constants, ContractConstants);
constants = Object.assign(constants, ContractDateConstants);
constants = Object.assign(constants, ConsigneeConstants);
constants = Object.assign(constants, ConsigneeUserConstants);
constants = Object.assign(constants, ClearingHouseAgent);
constants = Object.assign(constants, ChaUser);
constants = Object.assign(constants, ContainerConstants);
constants = Object.assign(constants, eximImportExportType);
constants = Object.assign(constants, CustomFieldConstants);
constants = Object.assign(constants, DashboardConstants);
constants = Object.assign(constants, DBConnectionConstants);
constants = Object.assign(constants, DetentionConstants);
constants = Object.assign(constants, { EmailType });
constants = Object.assign(constants, ExceptionConstants);
constants = Object.assign(constants, HttpResponseContants);
constants = Object.assign(constants, InvoiceContants);
constants = Object.assign(constants, IndianStates);
constants = Object.assign(constants, MdmConstants);
constants = Object.assign(constants, { MaxConsigneeFavouriteLimit });
constants = Object.assign(constants, { MongoDuplicateError });
constants = Object.assign(constants, OptimaConstants);
constants = Object.assign(constants, OrderConstants);
constants = Object.assign(constants, PaymentConstants);
constants = Object.assign(constants, Port);
constants = Object.assign(constants, FreightForwarder);
constants = Object.assign(constants, FreightForwarderUser);
constants = Object.assign(constants, TimelineConstants);
constants = Object.assign(constants, UtilisationStatus);
constants = Object.assign(constants, LocationTracker);
constants = Object.assign(constants, TrackAndTrace);
constants = Object.assign(constants, PushNotification);
constants = Object.assign(constants, Queue);
constants = Object.assign(constants, HolidayConstants);
constants = Object.assign(constants, RoleAssociates);
constants = Object.assign(constants, Wallet);
constants = Object.assign(constants, WalletV2);
constants = Object.assign(constants, WorkerJobs);
constants = Object.assign(constants, TrackingQueues);
constants = Object.assign(constants, Location);

constants = Object.assign(constants, UnitsConstants);

constants = Object.assign(constants, NimbusConstants);
constants = Object.assign(constants, NimbusModules);
constants = Object.assign(constants, NimbusDataTypes);

constants = Object.assign(constants, IdentityProviders);
constants = Object.assign(constants, FreightUnit);
constants = Object.assign(constants, MaterialCategoryConstants);
constants = Object.assign(constants, Transporter);
constants = Object.assign(constants, ConsigneeMailerConstants);
constants = Object.assign(constants, TransporterMailerConstants);
constants = Object.assign(constants, SlaDefaultConfig);
constants = Object.assign(constants, DepotConstant);
constants = Object.assign(constants, MaterialConstants);

constants = Object.assign(constants, WorkFlowConstants);
constants = Object.assign(constants, EximType);
constants = Object.assign(constants, EximMailer);
constants = Object.assign(constants, MasterIndentType);
constants = Object.assign(constants, MasterIndent);
constants = Object.assign(constants, ReportConstants);

constants = Object.assign(constants, DriverAppConstants);
constants = Object.assign(constants, PurchaseOrderConstants);
constants = Object.assign(constants, FreightBillConstants);
constants = Object.assign(constants, PackingConstants);
constants = Object.assign(constants, SourceCharge);

constants = Object.assign(constants, ErpBulkIndentConstants);
constants = Object.assign(constants, { definitionStrategies });
constants = Object.assign(constants, DataValuesConstants);
constants = Object.assign(constants, { InternalServices });

constants = Object.assign(constants, DateRollConstants);
constants = Object.assign(constants, MaraudersMap);

constants = Object.assign(constants, months);
constants = Object.assign(constants, vehicleDetail);
constants = Object.assign(constants, VehicleETA);
constants = Object.assign(constants, UpdatedByUserType);
constants = Object.assign(constants, ThirdPartyIntegrationConstants);
constants = Object.assign(constants, TransitDelayConstants);
constants = Object.assign(constants, InsuranceThresholdConstanst);
constants = Object.assign(constants, SobConstants);

constants = Object.assign(constants, DetentionConfigurationConstants);
constants = Object.assign(constants, ErrorMessages);
constants = Object.assign(constants, LrConfigurationConstants);
constants = Object.assign(constants, MaterialHeaderConfigurationConstants);
constants = Object.assign(constants, NotificationConstants);
constants = Object.assign(constants, PaidInvoiceExportConstants);
constants = Object.assign(constants, SlaConfigurationConstants);
constants = Object.assign(constants, SlotConfigurationConstants);
constants = Object.assign(constants, UnitConfigurationConstants);

constants = Object.assign(constants, dbActions);

constants = Object.assign(constants, BillDiscount);
constants = Object.assign(constants, contractTSDMapConstant);
constants = Object.assign(constants, conversationSection);
constants = Object.assign(constants, costCenter);
constants = Object.assign(constants, DedicatedTruck);
constants = Object.assign(constants, DieselPegConstants);
constants = Object.assign(constants, erpConstants);
constants = Object.assign(constants, freightProvision);
constants = Object.assign(constants, GateConstants);
constants = Object.assign(constants, defaultGrnHeader);
constants = Object.assign(constants, ewayBillConstants);
constants = Object.assign(constants, invoiceStatusConstants);
constants = Object.assign(constants, invoicePermissionConstants);
constants = Object.assign(constants, indentMaterialConstants);
constants = Object.assign(constants, OptimaConfiguration);
constants = Object.assign(constants, headerMapFields);
constants = Object.assign(constants, rateMatrix);
constants = Object.assign(constants, RatingWeights);
constants = Object.assign(constants, costCenterLoading);
constants = Object.assign(constants, LocationMilestone);
constants = Object.assign(constants, OrdersConstants);
constants = Object.assign(constants, Gst);
constants = Object.assign(constants, RFQConstants);
constants = Object.assign(constants, slaCostCenter);
constants = Object.assign(constants, TransitManagement);
constants = Object.assign(constants, TransportationDbConstants);
constants = Object.assign(constants, TRANSPORTER_ROLES);
constants = Object.assign(constants, user);
constants = Object.assign(constants, VehicleDetail);
constants = Object.assign(constants, Vehcile);
constants = Object.assign(constants, Driver);
constants = Object.assign(constants, VehicleDetails);
constants = Object.assign(constants, localisationConstants);
constants = Object.assign(constants, headerMapping);
constants = Object.assign(constants, indentDestinationCharges);

constants = Object.assign(constants, approvalConstants);
constants = Object.assign(constants, LrSeriesTypeConstants);
constants = Object.assign(constants, routerMasterConstants);
constants = Object.assign(constants, packagesConstants);
constants = Object.assign(constants, MaterialPackageMappingConstants);
constants = Object.assign(constants, DestinationChargeConstants);
constants = Object.assign(constants, materialThroughputConstants);
constants = Object.assign(constants, userAssociateConstants);
constants = Object.assign(constants, activityTimeConstants);
constants = Object.assign(constants, ChargeableWeightConstants);
constants = Object.assign(constants, DeviationNotification);
constants = Object.assign(constants, fcmDeviationNotificationMessage);
constants = Object.assign(constants, Transshipment);
constants = Object.assign(constants, Redirection);
constants = Object.assign(constants, OptimaMaterialCategory);
constants = Object.assign(constants, CourierConstants);
constants = Object.assign(constants, FreightZoneConstants);
constants = Object.assign(constants, IntegrationLogsConstants);
constants = Object.assign(constants, LegalEntityConstants);
constants = Object.assign(constants, ReturnManagement);
constants = Object.assign(constants, PaySettlement);
constants = Object.assign(constants, appDefaultConstants);
constants = Object.assign(constants, PermissionsList);
constants = Object.assign(constants, FeaturesList);
constants = Object.assign(constants, PandoIntelligence);

module.exports = constants;
